import { createContext, useContext } from 'react';
import type { StoredSession } from '@/utils/session';

export type Session = StoredSession;

export type SessionState =
  | { status: 'loading' }
  | { status: 'ready'; session: Session }
  | { status: 'signedOut' }
  | { status: 'error'; message: string };

export const SessionContext = createContext<SessionState | undefined>(undefined);

export const useSession = (): SessionState => {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession must be used within a session provider');
  return ctx;
};
